"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = void 0;
const interface_js_1 = require("./interface.js");
const options_js_1 = require("./options.js");
/**
 * Define a new set attribute
 * Note that set elements have constraints. They must be:
 * - Required (required: AtLeastOnce)
 * - Displayed (hidden: false)
 * - Not renamed (savedAs: undefined)
 * - Not defaulted (defaults: undefined)
 *
 * @param elements Attribute (With constraints)
 * @param options _(optional)_ List Options
 */
const set = (elements, options) => {
    const state = {
        ...options_js_1.SET_DEFAULT_OPTIONS,
        ...options,
        defaults: { ...options_js_1.SET_DEFAULT_OPTIONS.defaults, ...options === null || options === void 0 ? void 0 : options.defaults },
        links: { ...options_js_1.SET_DEFAULT_OPTIONS.links, ...options === null || options === void 0 ? void 0 : options.links },
        validators: { ...options_js_1.SET_DEFAULT_OPTIONS.validators, ...options === null || options === void 0 ? void 0 : options.validators }
    };
    return new interface_js_1.$SetAttribute(state, elements);
};
exports.set = set;
